module.exports = __webpack_public_path__ + "credit.f65812e8770512cde3b105997f340291.png";